var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.5,
    height: 36.5,
    viewBox: "0 0 36.5 36.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e88e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbdefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64b5f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heavy_rain",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(12.167 26.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M12.215,27.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,1,1,2.177,1.089l-1.217,2.433a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-11 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(4.867 26.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M6.215,27.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,1,1,2.177,1.089L7.306,27.195a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-5 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(7.3 31.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M8.215,31.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,1,1,2.177,1.089L9.306,31.2a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-7 -27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(14.6 31.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M14.215,31.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,1,1,2.177,1.089L15.306,31.2a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-13 -27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(21.9 31.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M20.215,31.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,1,1,2.177,1.089L21.306,31.2a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-19 -27)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(19.467 26.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M18.215,27.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,0,1,2.177,1.089l-1.217,2.433a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-17 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(26.767 26.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M24.215,27.867a1.215,1.215,0,0,1-1.086-1.761l1.217-2.433a1.217,1.217,0,0,1,2.177,1.089l-1.217,2.433a1.219,1.219,0,0,1-1.09.672Z",
    transform: "translate(-23 -23.001)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M27.767,5.867a9.738,9.738,0,0,0-1.75.155A10.89,10.89,0,0,0,16.817,1,11,11,0,0,0,6.293,8.933a8.517,8.517,0,0,0,3.224,16.4h18.25a9.733,9.733,0,0,0,0-19.467Z",
    transform: "translate(-1 -1)",
    fill: "url(#linear-gradient-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyRain);
export default __webpack_public_path__ + "static/media/heavy_rain.9766d56cd9f52c04c8d4af71ea96487a.svg";
export { ForwardRef as ReactComponent };